import React, { useState } from "react";
import styled from "styled-components";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import eucaly from "./images/EUCALY.png"
import { useTranslation } from 'react-i18next';


const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/';
    try {
      const response = await fetch(`${API_URL}login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json();
      if (response.ok) {
        setMessage(t("login.success"));
        sessionStorage.clear()
        localStorage.setItem("token", data.token);
        setTimeout(() => navigate("/"), 3000);
      } else {
        setMessage(t("login.invalid"));
       
      }
    } catch (error) {
      setMessage(t("login.network"));
      console.error("Login error:", error);
    }
  };

  const handleSignupClick = () => {
    navigate("/signup");
  };

  return (
    <LoginPage>
      <Header />
      <LoginBody>
        <Form onSubmit={handleSubmit}>
        <LoginTitle>{t('login.title')}</LoginTitle>
          <Input type="email" name="email" placeholder={t('login.email')} value={formData.email} onChange={handleChange} required />
          <PasswordInputWrapper>
          <Input type={showPassword ? "text" : "password"} name="password" placeholder={t('login.password')} value={formData.password} onChange={handleChange} onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault(); handleSubmit(e); }}} required />
          <EyeButton onClick={(e) => { e.preventDefault(); setShowPassword(!showPassword); }}>👁</EyeButton>
          </PasswordInputWrapper>
          <TextLink onClick={() => navigate("/forgot-password")}>
            {t('login.forgotPassword')}
          </TextLink>
          {message && <Message>{message}</Message>}
          <Button type="submit">{t('login.button')}</Button>
          <TextBottom>{t('login.member')} <SignupSpan onClick={handleSignupClick}>{t('login.signup')}</SignupSpan></TextBottom>
        </Form>
      </LoginBody>
      <Footer/>
    </LoginPage>
  );
};

export default Login;
  const LoginPage = styled.div` 
  background-color: rgba(148,163,135,1);
  background-image: url(${eucaly});
`

const LoginBody = styled.div`
   height: 100vh;
    font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  background-position: top;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
  padding-top:30px;
  @media (max-width: 700px) {
    padding-bottom:50px;
  }
`;
const LoginTitle = styled.p`
  font-size: 30px;
  text-align: center;
  font-weight: bold;
  color: black;
`;
const SignupSpan = styled.span`
  cursor: pointer;
  text-decoration: underline;
`;
const TextBottom = styled.p`
  text-align: center;
  color: black;
  font-weight: bold;
`;
const Form = styled.form`
  display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   width: 100%;
   max-width: 500px;
   margin-top: -90px;
   padding: 10px;
   background-color: rgba(255, 255, 255, 0.8);
   border-radius: 8px;
   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;
const Input = styled.input`
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  width:275px;
  border: 1px solid gray;
  margin-bottom: 15px;
`;
const Button = styled.button`
  background-color: rgba(148,163,135,1);
  color: white;
  padding: 10px;
  font-size: 16px;
  border: none;
  font-weight:bold;
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background-color: rgba(186,204,171,1);
  }
`;
const Message = styled.p`
  color: red;
  font-weight: bold;
  text-align: center;
`;
const PasswordInputWrapper = styled.div`
  position: relative;
  width: 300px;
`;

const EyeButton = styled.button`
  position: absolute;
  right: 10px;
  top: 35%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
`;
const TextLink = styled.p`
  cursor: pointer;
  text-decoration: underline;
  color: #333;
  margin-top: -10px;
  margin-bottom: 15px;
  font-size: 14px;
  text-align: right;
  width: 275px;
`;